export default "__VITE_ASSET__LzB5jPE4__"